import { _ as __vite_glob_0_0 } from "../CameraFollowOnSpawn-16a4734f.js";
import { _ as __vite_glob_0_1 } from "../Description-c36d0b9a.js";
import { _ as __vite_glob_0_2 } from "../Events-7b5dd49f.js";
import { _ as __vite_glob_0_3 } from "../FrameRate-7ce72a03.js";
import { _ as __vite_glob_0_4 } from "../Owned-84ee52ae.js";
import { _ as __vite_glob_0_5 } from "../Owner-4cb1d33a.js";
import { _ as __vite_glob_0_6 } from "../PlayerInput-ad722e2d.js";
import { _ as __vite_glob_0_7 } from "../Random-b6daba3a.js";
import { _ as __vite_glob_0_8 } from "../SpatialMap-56228ece.js";
import { _ as __vite_glob_0_9 } from "../TimeDilation-41a74cd7.js";
import { _ as __vite_glob_0_10 } from "../Attach-abbbd93e.js";
import { _ as __vite_glob_0_11 } from "../Attached-c11af1dc.js";
import { _ as __vite_glob_0_12 } from "../Child-888ef1d8.js";
import { _ as __vite_glob_0_13 } from "../Locomotion-379972de.js";
import { _ as __vite_glob_0_14 } from "../NoLocomotion-8fddd32b.js";
import { _ as __vite_glob_0_15 } from "../Parent-b4f1af10.js";
import { _ as __vite_glob_0_16 } from "../Radius-89a665f8.js";
import { _ as __vite_glob_0_17 } from "../SwapComponents-882395c8.js";
import { _ as __vite_glob_0_18 } from "../Transform-9450b7b5.js";
import { _ as __vite_glob_0_19 } from "../Collisions-9e9492fb.js";
import { _ as __vite_glob_0_20 } from "../Physics-8d447f7a.js";
import { _ as __vite_glob_0_21 } from "../RigidBox-423b8c11.js";
import { _ as __vite_glob_0_22 } from "../RigidCircle-ee2bcb73.js";
import { _ as __vite_glob_0_23 } from "../RigidPolygon-b7405623.js";
import { registerSchema } from "../components/ComponentRegistry.js";
import "../components/camera/CameraFollowOnSpawn.js";
import "../components/camera/EntityCamera.js";
import "../components/camera/SelfCamera.js";
import "../components/core/Animate.js";
import "../components/core/FrameRate.js";
import "../components/core/ListenEntityCreation.js";
import "../components/core/Owned.js";
import "../components/core/Owner.js";
import "../components/core/Random.js";
import "../components/core/SpatialMap.js";
import "../components/entity/Attach.js";
import "../components/entity/Child.js";
import "../components/entity/Locomotion.js";
import "../components/entity/NoLocomotion.js";
import "../components/entity/Parent.js";
import "../components/entity/Radius.js";
import "../components/entity/Spawn.js";
import "../components/entity/SwapComponents.js";
import "../components/entity/Types.js";
import "../components/physics/Physics.js";
import "../components/physics/RigidBox.js";
import "../components/physics/RigidCircle.js";
import "../components/physics/RigidPolygon.js";
import "../components/render/Graphic.js";
import "../components/render/ImportantSprite.js";
import "../components/render/MapSprite.js";
import "../components/render/Mask.js";
import "../components/render/Spine.js";
import "../components/render/Sprite.js";
import "../components/render/VisibleConditional.js";
import "../components/timeouts/DestroyOnTimeoutComponent.js";
import "../components/timeouts/DieOnTimeout.js";
import "../components/timeouts/SpawnOnTimeout.js";
import { _ as __vite_glob_0_33 } from "../DieOnTimeout-1359a71f.js";
import "../components/types.js";
import { _ as __vite_glob_0_25 } from "../Graphic-f0e31eeb.js";
import { _ as __vite_glob_0_26 } from "../ImportantSprite-329bc41a.js";
import { _ as __vite_glob_0_27 } from "../MapSprite-b447e6f3.js";
import { _ as __vite_glob_0_28 } from "../Mask-de6e3148.js";
import { _ as __vite_glob_0_29 } from "../Spine-11fceea9.js";
import { _ as __vite_glob_0_30 } from "../Sprite-7d2a5fa7.js";
import { _ as __vite_glob_0_31 } from "../VisibleConditional-7a953c26.js";
import { _ as __vite_glob_0_32 } from "../DestroyOnTimeoutComponent-72b9efed.js";
import { _ as __vite_glob_0_34 } from "../FadeOnTimeoutComponent-a83db7ee.js";
import { _ as __vite_glob_0_35 } from "../SpawnOnTimeoutComponent-0dd66b5e.js";
import { C as ComponentCategory } from "../enums-86f58524.js";
import "../decorators/type.js";
import "ajv";
import "../utils/clone.js";
import "bitecs";
import "../utils/typehelpers.js";
import "../global-33d5eebf.js";
import "../utils/vector.js";
import "../utils/byteArray.js";
import "../constants/index.js";
import "../entity/EntityFactory.js";
import "../loader/AssetLoader.js";
import "../loader/ImageLoader.js";
import "pixi.js";
import "../loader/SpriteLoader.js";
import "../loader/PixiSpriteLoader.js";
import "../loader/MapLoader.js";
import "../utils/colors.js";
import "../utils/sharedFetch.js";
import "../vendor/noise/index.js";
import "url";
import "@dimforge/rapier2d-compat";
import "../persist/persist.js";
import "../loader/PixiSpineLoader.js";
import "pixi-spine";
import "../loader/SoundLoader.js";
import "../_commonjsHelpers-7a77ea84.js";
import "toposort";
import "lodash";
import "../ui/Rectangle.js";
import "../ui/Text.js";
import "../ui/UIElement.js";
import "nanoid";
import "../ui/utils.js";
import "../ui/UIService.js";
import "../inputs/InputManager.js";
import "../utils/playSound.js";
import "../console/flags.js";
import "../console/editor.js";
import "../console/floatingwindow.js";
import "../utils/windowSessionStorage.js";
import "../utils/rand.js";
import "seedrandom";
import "../utils/Collision.js";
import "../utils/isometric.js";
const __vite_glob_0_24 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null
}, Symbol.toStringTag, { value: "Module" }));
const schemas = /* @__PURE__ */ Object.assign({ "./camera/CameraFollowOnSpawn.ts": __vite_glob_0_0, "./core/Description.ts": __vite_glob_0_1, "./core/Events.ts": __vite_glob_0_2, "./core/FrameRate.ts": __vite_glob_0_3, "./core/Owned.ts": __vite_glob_0_4, "./core/Owner.ts": __vite_glob_0_5, "./core/PlayerInput.ts": __vite_glob_0_6, "./core/Random.ts": __vite_glob_0_7, "./core/SpatialMap.ts": __vite_glob_0_8, "./core/TimeDilation.ts": __vite_glob_0_9, "./entity/Attach.ts": __vite_glob_0_10, "./entity/Attached.ts": __vite_glob_0_11, "./entity/Child.ts": __vite_glob_0_12, "./entity/Locomotion.ts": __vite_glob_0_13, "./entity/NoLocomotion.ts": __vite_glob_0_14, "./entity/Parent.ts": __vite_glob_0_15, "./entity/Radius.ts": __vite_glob_0_16, "./entity/SwapComponents.ts": __vite_glob_0_17, "./entity/Transform.ts": __vite_glob_0_18, "./physics/Collisions.ts": __vite_glob_0_19, "./physics/Physics.ts": __vite_glob_0_20, "./physics/RigidBox.ts": __vite_glob_0_21, "./physics/RigidCircle.ts": __vite_glob_0_22, "./physics/RigidPolygon.ts": __vite_glob_0_23, "./preload.ts": __vite_glob_0_24, "./render/Graphic.ts": __vite_glob_0_25, "./render/ImportantSprite.ts": __vite_glob_0_26, "./render/MapSprite.ts": __vite_glob_0_27, "./render/Mask.ts": __vite_glob_0_28, "./render/Spine.ts": __vite_glob_0_29, "./render/Sprite.ts": __vite_glob_0_30, "./render/VisibleConditional.ts": __vite_glob_0_31, "./timeouts/DestroyOnTimeoutComponent.ts": __vite_glob_0_32, "./timeouts/DieOnTimeout.ts": __vite_glob_0_33, "./timeouts/FadeOnTimeoutComponent.ts": __vite_glob_0_34, "./timeouts/SpawnOnTimeoutComponent.ts": __vite_glob_0_35 });
const exports = {};
for (const schemaImport of Object.values(schemas)) {
  const schema = schemaImport;
  const keys = Object.keys(schema);
  keys.forEach((key) => {
    if (typeof schema[key] !== "function") {
      throw new Error(`Schema ${key} is not a function`);
    }
    if (schema[key].__category === void 0) {
      registerSchema(ComponentCategory.NONE, schema[key]);
    } else {
      registerSchema(schema[key].__category, schema[key]);
    }
  });
}
export {
  exports as default
};
//# sourceMappingURL=index.js.map
